import React, { useEffect } from 'react';

import { useWelcomeBonusQuery } from 'api/queries/bankrollQueries';
import { displayWarningNotification } from 'components/layout/notifications/notificationsUtils';
import { clearBankrollCode } from 'reduxState/currentUserData/userBankroll';
import { staticDispatch } from 'reduxState/store';
import { useSelector } from 'reduxState/storeCore';

import BankrollConnectModal from './BankrollConnectModal';
import {
  DEFAULT_WELCOME_BONUS_MESSAGE,
  useAutomaticallyApplyPointsBankrollCode,
} from './bankrollFn';

export default function WelcomePointsModal({
  pointsBonusCode,
  onClose,
}: {
  pointsBonusCode: string | undefined;
  onClose?: () => void;
}) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const unlockModalOpen = useSelector(
    state => state.walletDetail.unlockModalOpen
  );

  const { data: bankrollData } = useWelcomeBonusQuery(pointsBonusCode);

  const isValid =
    bankrollData?.welcomeBonus && bankrollData.welcomeBonus.canRedeem;

  const { applying } = useAutomaticallyApplyPointsBankrollCode(
    pointsBonusCode,
    !!isValid
  );

  useEffect(() => {
    if (bankrollData && !isValid) {
      staticDispatch(clearBankrollCode());
      displayWarningNotification('This promotional offer is no longer valid');
    }
  }, [bankrollData, isValid]);

  if (!bankrollData) {
    console.warn('Missing bankroll data');
    return null;
  }

  if (applying || unlockModalOpen || !isValid) {
    return null;
  }

  const { welcomeBonus } = bankrollData;

  if (welcomeBonus === undefined) {
    // Loading
    return null;
  }
  // if (!isValid) {
  //   return <BankrollInvalidModal onClose={() => { onClose(); if (!isValid) { // On any error wipe code globally   staticDispatch(clearBankrollCode(undefined)); } }} />;
  // }
  if (!walletAddress) {
    return (
      <BankrollConnectModal
        onClose={onClose}
        message={DEFAULT_WELCOME_BONUS_MESSAGE}
        referralRateOverride={welcomeBonus?.referralRateOverride ?? undefined}
        referredDiscountRateOverride={
          welcomeBonus?.referredDiscountRateOverride ?? undefined
        }
      />
    );
  }
  return null;
}
